import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import TermsOfUseText from '../components/TermsOfUseText';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const TermsOfUse = () => {
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
      title: window.location.title,
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Browse Terms of Use Lipaworld | Lipaworld Corp</title>
        <meta
          name="description"
          content="Review our terms of use to understand your rights and responsibilities while using Lipaworld's secure financial platforms and global marketplace."
        />
        <link rel="canonical" href="https://www.lipaworld.com/terms-of-use" />
      </Helmet>
      <div className="min-h-screen ">
        <div className="container mx-auto px-4">
          <Header />
          <SEO path="/terms-of-use" />
          <main>
            <TermsOfUseText />
          </main>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
